// extracted by mini-css-extract-plugin
export var cdsAssistiveText = "PageDescription-module--cds--assistive-text--37555";
export var cdsVisuallyHidden = "PageDescription-module--cds--visually-hidden--0bd3e";
export var hideFeedback = "PageDescription-module--hide-feedback--df771";
export var pageDescription = "PageDescription-module--page-description--23dbc";
export var showFeedback = "PageDescription-module--show-feedback--7af90";
export var skeleton = "PageDescription-module--skeleton--4d372";